import * as comlink from 'comlink';
import * as comberter from '@comberter/comberter';
import * as FileUploadHelper from '@/js/utilities/file_upload_helper';
comlink.expose({
    async getWorksheetNames(buffer) {
        return FileUploadHelper.getWorksheetNames(buffer);
    },
    async getMaxRow(content, sheetName) {
        return FileUploadHelper.getMaxRow(content, sheetName);
    },
    async getMaxColumn(content, sheetName) {
        return FileUploadHelper.getMaxColumn(content, sheetName);
    },
    async parseFileContent(content, sheetName) {
        const tsv = FileUploadHelper.extractTsv(content, sheetName);
        return FileUploadHelper.parseTsv(tsv);
    },
    async convert(inputFileContent, worksheet, startRow, endRow, peptideSequenceColumn, glycanStructureColumn, modificationTypeColumn, fastaHeaderColumn, peptideStartingPositionColumn) {
        const tsv = FileUploadHelper.extractTsv(inputFileContent, worksheet);
        const parsedTsv = FileUploadHelper.parseTsv(tsv);
        const collectInput = (column) => parsedTsv
            .slice(startRow, endRow + 1)
            .map(line => (column < line.length ? line[column] : ''))
            .map(cell => cell.toString());
        const peptides = collectInput(peptideSequenceColumn);
        const glycans = collectInput(glycanStructureColumn);
        const modificationTypes = collectInput(modificationTypeColumn);
        const fastaHeadersOpt = fastaHeaderColumn >= 0 ? collectInput(fastaHeaderColumn) : undefined;
        const peptideStartingPositionsOpt = peptideStartingPositionColumn >= 0
            ? collectInput(peptideStartingPositionColumn)
            : undefined;
        try {
            const result = await comberter.runComberter({
                peptideList: peptides,
                glycanList: glycans,
                modificationListOpt: modificationTypes,
                uniprotIdListOpt: fastaHeadersOpt,
                proteinPositionListOpt: peptideStartingPositionsOpt,
            });
            const wurcsResult = await comberter.collectWurcsWithoutGtcId(result.result);
            return {
                result,
                wurcsResult,
            };
        }
        catch (e) {
            console.error(e);
            return {
                result: { result: '', errors: [e.toString()] },
                wurcsResult: { result: [], errors: [] },
            };
        }
    },
});
